<template>
    <v-container>
        <v-row >
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">Venom Types</h2>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="12" sm="3" offset-sm="1">
                            <v-checkbox
                                label="Active Only"
                                v-model="venomTypesActiveOnly"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" offset-sm="1">
                        </v-col>
                        <v-col cols="12" sm="2" offset-sm="1">
                            <v-btn
                                v-if="!auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="editVenomType({ Active: true })"
                            >
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col>
                            <v-progress-linear v-if="venomTypesLoading" slot="progress" color="primary" indeterminate></v-progress-linear>
                            <v-data-table v-else
                                :headers="headers"
                                :items="venomTypesFiltered"
                                :loading="venomTypesLoading"
                                :footer-props="footerProps"
                                must-sort
                            >
                                <template slot="item" slot-scope="props">
                                    <tr :data-id="props.item.VenomTypeID">
                                        <td>{{props.item.VenomTypeName}}</td>
                                        <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                        <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                        <td v-if="!auth.currentUserIsReadOnly()">
                                            <v-btn
                                                color="warning"
                                                block
                                                @click="editVenomType(props.item)"
                                            >
                                                Edit
                                            </v-btn>
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </template>
                                <template v-if="!venomTypesLoading" slot="no-data">
                                    <v-alert v-if="venomTypesLoadError" outlined :value="true" color="error" icon="error">
                                        {{venomTypesLoadError}}
                                    </v-alert>
                                    <v-alert v-if="!venomTypesLoadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- END LOCATION TYPES -->

        </v-row>
        
        <!-- LOCATION TYPE DIALOG -->
        <v-dialog v-model="venomTypeshowEditDialog" transition="dialog-bottom-transition" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="venomTypesSaving" @click="cancelEditVenomType">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="venomTypeEdited && venomTypeEdited.VenomTypeID">Edit Venom Type</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Venom Type</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="venomTypeEditValid">
                    <v-row class="dialog-content">
                        <v-col cols="12">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="100"
                                        maxlength="100"
                                        v-model="venomTypeEdited.VenomTypeName"
                                        :rules="[rules.required]"
                                        label="Venom Type">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox label="Active" v-model="venomTypeEdited.Active"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="6">
                                    <v-btn block color="error" :disabled="venomTypesSaving" @click="cancelEditVenomType">Cancel</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-btn block color="success" :disabled="!venomTypeEditValid" :loading="venomTypesSaving" @click="saveEditedVenomType">Save</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="venomTypesSaveError">
                                    <v-alert text type="error">{{ venomTypesSaveError }}</v-alert>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- END LOCATION TYPE DIALOG -->

    </v-container>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import * as auth from '@/services/auth';
import { mapState } from 'vuex';

export default {
    components: {
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth,
            rules: validationRules.rules,
            
            footerProps: {
                'items-per-page-options': [20, 50, 100]
            },
            headers: [
                {
                    text: 'Venom Type',
                    value: "VenomTypeName"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false,
                    width: "100px"
                }
            ],

            venomTypesActiveOnly: true,
            venomTypeEdited: {},
            venomTypeshowEditDialog: false,
            venomTypeEditValid: false
        };
    },
    computed: {
        ...mapState("venomTypeStore", {
            venomTypes: state => state.venomTypes,
            
            venomTypesLoading: state => state.venomTypesLoading,
            
            venomTypesLoadError: state => state.venomTypesLoadError,

            venomTypesSaving: state => state.venomTypesSaving,

            venomTypesSaveError: state => state.venomTypesSaveError,
        }),
        venomTypesFiltered() {
            return this.venomTypes.filter(s => s.Active || !this.venomTypesActiveOnly);
        },
    },
    methods: {
        loadVenomTypes() {
            this.$store.dispatch("venomTypeStore/loadVenomTypes");
        },
        
        editVenomType(item) {
            this.$store.dispatch("venomTypeStore/clearSaveErrors");
            this.venomTypeEdited = Object.assign({}, item);
            this.venomTypeshowEditDialog = true;
            this.$nextTick(() => this.$refs.editForm.validate()); // show which fields are mandatory when opening the edit form
        },
        cancelEditVenomType() {
            this.venomTypeshowEditDialog = false;
            this.venomTypeEdited = {};
        },
        saveEditedVenomType() {
            var that = this;

            this.$store.dispatch("venomTypeStore/saveVenomType", {
                venomType: this.venomTypeEdited,
                finally: function() {
                    if (!that.venomTypesSaveError) {
                        // only close dialog if there was no error (error will be displayed automatically if it exists)
                        that.cancelEditVenomType();
                    }
                }
            });
        },

    },
    created() {
        this.loadVenomTypes();
    }
};
</script>

<style>
    
</style>